import type { Extension } from '@atlassian/forge-ui/web-client/graphql/types';

export const isBlockedByAppAccessRule = (extension?: Extension): boolean =>
	extension?.dataClassificationPolicyDecision?.status === 'BLOCKED';
